<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>三方门店列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
          <el-form
            size="mini"
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >

            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="所属省份"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="店铺名称" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="编号" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="类型" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.grade_id"
                style="width: 180px;"
                placeholder="请选择类别"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">

                </el-option>
              </el-select>

            </el-form-item>
            <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" size="mini" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        border
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >

        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="名称"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="编码"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.sn}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分类"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.category?scope.row.category.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.cont_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系电话"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.telephone}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属区域"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.province?scope.row.province.region_name:''}}</span>
            <span>{{scope.row.city?scope.row.city.region_name:''}}</span>
            <span>{{scope.row.district?scope.row.district.region_name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="地址"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="审核状态"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span style="color:#ff0000">{{ scope.row.is_auth==0?'待审核':'' }}</span>
            <span style="color: #5daf34">{{ scope.row.is_auth==1?'已审核':'' }}</span>
            <span style="color: #E6A23C">{{ scope.row.is_auth==2?'驳回':'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
                width="200"
                label="商户号"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.paysourceparams">
              <p style="color:#ff0000">三方平台商户号:{{ scope.row.paysourceparams.cusid }}</p>
              <p style="color: #5daf34">营销商户号:{{ scope.row.paysourceparams.service_cusid }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="160">
          <template slot-scope="scope">

            <el-dropdown  size="mini"  split-button  trigger="click">
              更多操作
              <el-dropdown-menu trigger="click">
                <el-dropdown-item @click.native="goAuth(scope.row)">审核</el-dropdown-item>
                <el-dropdown-item  @click.native="goInfo(scope.row)">查看</el-dropdown-item>
                <el-dropdown-item @click.native="goEdit(scope.row)" >修改</el-dropdown-item>
                <el-dropdown-item @click.native="goBindOil(scope.row)">绑定油站</el-dropdown-item>
                <el-dropdown-item @click.native="goUser(scope.row)">增加管理员</el-dropdown-item>
                <el-dropdown-item @click.native="goPaySourceParams(scope.row)">编辑支付账号</el-dropdown-item>
                <el-dropdown-item @click.native="goBank(scope.row)">添加转账银行</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"  :readonly="true" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-select
            v-model="form.is_auth"
            style="width: 180px;"
            placeholder="请选择类别"
          >
            <el-option
              v-for="item in authList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <eFileList
      :formData="formData1"
      :visible="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
    <eShopUserForm
            :formData="formData2"
            :visible="visible2"
            :title="title2"
            :closeForm="closeForm2"
    />
    <ePaySourceParamsForm
            :formData="formData3"
            :visible="visible3"
            :title="title3"
            :closeForm="closeForm3"
    />
    <eShopBankForm
            :formData="formData4"
            :visible="visible4"
            :title="title4"
            :closeForm="closeForm4"
    />
    <eBindOilShopList
            :formData="formData5"
            :visible="visible5"
            :title="title5"
            :closeForm="closeForm5"
    />
  </div>
</template>

<script>
  import eFileList from "./components/eFileList.vue";
  import eShopUserForm from "./components/eShopUserForm.vue";
  import ePaySourceParamsForm from "./components/ePaySourceParamsThirdForm.vue";
  import eShopBankForm from "./components/eShopBankForm.vue";
  import eBindOilShopList from "./components/eBindOilShopList.vue";
  import moment from 'moment'     //日期时间转换

  export default {
    name: "thirdShopList",
    components: {
      eFileList,eShopUserForm,ePaySourceParamsForm,eShopBankForm,eBindOilShopList
    },
    props: {},
    data() {
      return {
        authList:[{id:0,name:'待审核'},{id:1,name:'已审核'},{id:2,name:'上级驳回'}],
        formData1:{},
        visible1:false,
        title1: '',

        formData2:{},
        visible2:false,
        title2: '',

        formData3:{},
        visible3:false,
        title3: '',

        formData4:{},
        visible4:false,
        title4: '',

        formData5:{},
        visible5:false,
        title5: '',

        gradeList:[],
        // 搜索
        searchForm: {
          name: "",
          cate_id:12,
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
          id:'',
          is_auth:'',
        },

      };
    },
    created() {

      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {

      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      goBindOil(row){
       this.formData5.id=row.id;
       this.visible5=true;
      },
      closeForm5() {
        this.title5 = "";
        this.visible5 = false;
      },
      goUser(row){
        this.formData2=row;
        this.formData2.shop_id=row.id;
        this.formData2.role_id=31;
        this.title2=row.name+"添加管理员";
        this.visible2=true;
        console.log(row)
      },
      closeForm2() {
        this.title2 = "";
        this.visible2 = false;
      },
      goPaySourceParams(row){
        this.formData3.type_id=1;
        this.formData3.item=row;
        this.formData3.shop_id=row.id;
        this.title3=row.name+"：编辑支付商户号";
        this.visible3=true;
        console.log(row)
      },
      closeForm3() {

        this.title3 = "";
        this.pageNum=1;
        this.tableLoadData=[];
        this.DataList();
        this.visible3 = false;

      },

      goBank(row){
        this.formData4=row;
        this.formData4.shop_id=row.id;
        this.title4=row.name+"：添加转账银行";
        this.visible4=true;
        console.log(row)
      },
      closeForm4() {
        this.title4 = "";
        this.visible4 = false;
      },

      goAuth(row){
        this.form.id=row.id;
        this.form.name=row.name;
        this.form.is_auth=row.is_auth;
        this.dialogFormVisible=true;
      },
      goFile(row){
        this.visible1=true;
        this.formData1.shop_id=row.id;
        this.title1="图片资料";
      },
      closeForm1() {
        this.title1 = "";
        this.visible1 = false;
      },
      goInfo(row){
        this.$router.push({
          path:'/thirdShopInfo',
          query:{
            id:row.id
          }
        })
      },
      goEdit(row){
        this.$router.push({
          path:'/thirdShopForm',
          query:{
            id:row.id
          }
        })
      },

      goCategory(){
        this.$router.push('/newsCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          cate_id:12,
          pageNum:this.pageNum,
          pageSize:this.pageSize
        }
        this.$axios.shopByShopListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total=res.data.total;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push({name:'thirdShopForm'})
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {

        this.$refs[formName].validate((valid) => {

          if (valid) {

            if(this.form.id){
              const param = {
                id: this.form.id,
                is_auth: this.form.is_auth,
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.shopAuth(param).then(res =>{

                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
         this.pageNum=1;

         this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
